import React from 'react'
import PropTypes from 'prop-types'
import { TimelineLite } from 'gsap/TimelineLite'
import PlainText from '../components/PlainText'
import globals from '../globals'

class Terms extends React.Component {
    constructor (props) {
        super(props)

        this.items = []
        this.svgs = []
    }

    componentDidUpdate (prevProps) {
	    if (prevProps.data !== this.props.data && this.props.data.length === 1) {
	        this.animateOpen(this.items[0], this.svgs[0])
        }
    }

    handleClick (event, key) {
        event.preventDefault()
        const item = this.items[key]
        const svg = this.svgs[key]

        if (this.items[key].classList.contains('closed')) {
            this.animateOpen(item, svg)
        } else {
            this.animateClosed(item, svg)
        }
    }

    animateOpen (item, svg) {
        item.classList.remove('closed')
        item.classList.add('open')

        const tl = new TimelineLite()
        const content = item.querySelector('.content')
        const title = item.querySelector('.title')

        tl.set(content, { display: 'block', height: 'auto' })
        tl.from(content, 0.25, { height: 0 })
        tl.to(svg, 0.2, { rotation: 0, transformOrigin: '50% 50%' }, 0)
        tl.to(title, 0.05, { paddingTop: '35px' }, 0)
        tl.to(item, 0.05, { paddingBottom: '20px' }, 0)
    }

    animateClosed (item, svg) {
        item.classList.remove('open')
        item.classList.add('closed')

        const tl = new TimelineLite()
        const content = item.querySelector('.content')
        const title = item.querySelector('.title')

        tl.to(content, 0.25, { height: 0 })
        tl.set(content, { display: 'none', height: 'auto' })
        tl.to(svg, 0.2, { rotation: 90, transformOrigin: '50% 50%' }, 0)
        tl.to(title, 0.05, { paddingTop: '17px' }, 0)
        tl.to(item, 0.05, { paddingBottom: 0 }, 0)
    }

    render () {
        const Rows = this.props.data.map((item, key) => {
            return (
                <div key={key} className='item closed' ref={el => this.items[key] = el}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 34.02 34.02'
                        className='toggle-icon'
                        onClick={event => this.handleClick(event, key)}
                    >
                        <g id='Layer_2' data-name='Layer 2'>
                            <g id='Layer_1-2' data-name='Layer 1'>
                                <rect className='cls-1' y='12.76' width='34.02' height='8.5' rx='4.25' fill='#004346' />
                                <rect
                                    className='cls-1' y='12.76' width='34.02' height='8.5' rx='4.25' fill='#004346' ref={el => this.svgs[key] = el}
                                    transform='translate(0 34.02) rotate(-90)'
                                />
                            </g>
                        </g>
                    </svg>
                    <a href='#' className='title color-indigo' onClick={event => this.handleClick(event, key)} dangerouslySetInnerHTML={{ __html: globals.noWidows(item[0]) }} />
                    <div className='content'>
                        <PlainText data={item} excludeTitle />
                    </div>
                </div>
            )
        })

        return (
            <div className='row terms-module' id='terms'>
                <div className='col-12 col-lg-8 offset-lg-2'>
                    <div className='row mt-3 mt-lg-5'>
                        <div className='col-12'>
                            {Rows}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Terms.propTypes = {
    data: PropTypes.array.isRequired
}

export default Terms



// WEBPACK FOOTER //
// ./resources/js/components/Terms.js